import HTTP from '../http'
import Note from './noteModel'

const noteService = {
  addNote (note: any) {
    return HTTP.post('', {
      query: `
        mutation ($data: NoteInput!) {
          addNote (data: $data)
        }
      `,
      variables: {
        data: note
      }
    })
  },
  getNotesByClientId (clientId: string, noteTypes: number[] = [0, 10]) {
    return HTTP.post('', {
      query: `
        query Notes($clientId: String!, $noteTypes: [Float]) {
          notes (clientId: $clientId, noteTypes: $noteTypes) {
            id,
            noteType,
            noteTypeName,
            clientId,
            value,
            createdDate,
            createdById,
            createdByName
          }
        }
      `,
      variables: {
        clientId: clientId,
        noteTypes: noteTypes
      }
    }).then((res: any) => {
      const results = res.data.data.notes.map((note: any) => new Note(note))
      return results
    })
  },
  getCcoas (clientId: string) {
    return this.getNotesByClientId(clientId, [ 30 ])
  },
  getGoals (clientId: string) {
    return this.getNotesByClientId(clientId, [ 15 ])
  },
  getSelectors (clientId: string) {
    return this.getNotesByClientId(clientId, [ 40 ])
  }
}

export default noteService
